import { render } from "./PlaceBet.vue?vue&type=template&id=6daf0037"
import script from "./PlaceBet.vue?vue&type=script&lang=js"
export * from "./PlaceBet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__